module.exports = __webpack_public_path__ + "static/media/0029.8fb3126c.png";